// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BundleDocumentViewer_card__cdmCJ {
    background-color: var(--gray) !important;
    border-radius: 1rem !important;
    color: var(--secondary-color) !important;
    border: outset !important;
    min-height: 10rem;
    height: auto !important;
    overflow: hidden;
}

.BundleDocumentViewer_card__cdmCJ .card-body {
    min-width: 0;
}

.BundleDocumentViewer_detail__ZUesl {
    min-width: 0;
    flex-wrap: wrap;
}

.BundleDocumentViewer_detailValue__RPtE1 {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.BundleDocumentViewer_scrollable__Eiq6k {
    max-height: 44rem;
    overflow-y: auto;
    overflow-x: hidden;
}

.BundleDocumentViewer_scrollable__Eiq6k::-webkit-scrollbar {
    width: 0.4rem;
    background: var(--lightGray);
}

.BundleDocumentViewer_scrollable__Eiq6k::-webkit-scrollbar-track {
    border-radius: 0.5rem;
}

.BundleDocumentViewer_scrollable__Eiq6k::-webkit-scrollbar-thumb {
    background: var(--gray);
}

.BundleDocumentViewer_scrollable__Eiq6k::-webkit-scrollbar-thumb:hover {
    background: var(--secondary-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/BundleViewer/BundleDocumentViewer.module.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,8BAA8B;IAC9B,wCAAwC;IACxC,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".card {\n    background-color: var(--gray) !important;\n    border-radius: 1rem !important;\n    color: var(--secondary-color) !important;\n    border: outset !important;\n    min-height: 10rem;\n    height: auto !important;\n    overflow: hidden;\n}\n\n.card :global(.card-body) {\n    min-width: 0;\n}\n\n.detail {\n    min-width: 0;\n    flex-wrap: wrap;\n}\n\n.detailValue {\n    min-width: 0;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n}\n\n.scrollable {\n    max-height: 44rem;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.scrollable::-webkit-scrollbar {\n    width: 0.4rem;\n    background: var(--lightGray);\n}\n\n.scrollable::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n}\n\n.scrollable::-webkit-scrollbar-thumb {\n    background: var(--gray);\n}\n\n.scrollable::-webkit-scrollbar-thumb:hover {\n    background: var(--secondary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `BundleDocumentViewer_card__cdmCJ`,
	"detail": `BundleDocumentViewer_detail__ZUesl`,
	"detailValue": `BundleDocumentViewer_detailValue__RPtE1`,
	"scrollable": `BundleDocumentViewer_scrollable__Eiq6k`
};
export default ___CSS_LOADER_EXPORT___;
